import {
  GET_DATA_FEEDS_STATUS_FAILURE,
  GET_DATA_FEEDS_STATUS_SUCCESS,
} from '../../../../../store/actionTypes';

/**
 * initial state data
 */
const initialState: any = {
  dataFeedStatus: false,
  error: false,
  loading: true,
};

/**
 * Reducer for managing the datafeed form change state
 * @param state
 * @param action
 * @returns
 */
const formChangeReducer = (state = initialState, action: any): any => {
  let payload: any;
  const data = action.data && action.data.data;
  switch (action.type) {
    case GET_DATA_FEEDS_STATUS_SUCCESS:
      payload = Object.assign([], state.dataFeedStatus, data);
      return { ...state, dataFeedStatus: payload, loading: false };
    case GET_DATA_FEEDS_STATUS_FAILURE:
      return { ...state, dataFeedStatus: false, error: true, loading: false };
    default:
      return {
        ...state,
      };
  }
};
export default formChangeReducer;
